import { z } from 'zod';

// The consent screen's contract — the only part of the MCP server we host that the
// admin SPA ever touches. The OAuth endpoints themselves speak the protocol's own
// wire format to Claude, not this.

// `write` tools change knowledge-base articles (drafts and explicit approvals); the
// consent page groups them apart from the reads so staff see what they are granting.
export const McpToolAccessSchema = z.enum(['read', 'write']);

export const McpConsentToolSchema = z.object({
  name: z.string(),
  description: z.string(),
  access: McpToolAccessSchema,
});

export const McpConsentViewSchema = z.object({
  requestId: z.uuid(),
  // The host that served the client metadata document. The document's own
  // `client_name` is self-asserted text, so it is never shown.
  clientHost: z.string(),
  callbackOrigin: z.string(),
  issuer: z.string(),
  resource: z.string(),
  tools: McpConsentToolSchema.array(),
});

export const McpConsentDecisionSchema = z.object({
  requestId: z.uuid(),
  decision: z.enum(['approve', 'deny']),
});

export const McpConsentResultSchema = z.object({
  redirectUrl: z.string(),
});

export type McpToolAccess = z.infer<typeof McpToolAccessSchema>;
export type McpConsentTool = z.infer<typeof McpConsentToolSchema>;
export type McpConsentView = z.infer<typeof McpConsentViewSchema>;
export type McpConsentDecision = z.infer<typeof McpConsentDecisionSchema>;
export type McpConsentResult = z.infer<typeof McpConsentResultSchema>;
